import * as React from 'react';

export function SvgBannerVectorUp(props: any) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="11"
      viewBox="0 0 24 11"
      fill="none"
      {...props}
    >
      <path
        d="M24 11L0 11L9.17157 1.82843C10.7337 0.266331 13.2663 0.26633 14.8284 1.82843L24 11Z"
        fill="currentColor"
      />
    </svg>
  );
}
